"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TextInfoContent["default"];
  }
});

var _TextInfoContent = _interopRequireDefault(require("./TextInfoContent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@mui-treasury/components/content/textInfo/index.js
// module id = 944
// module chunks = 0